export const storage = {
  setItem: (key: string, item: string) => {
    try {
      return localStorage.setItem(key, item);
    } catch (e) {
      console.error(e);
    }
  },
  getItem: <T extends string>(key: string) => {
    try {
      return localStorage.getItem(key) as T | null;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  setJSONItem: (
    key: string,
    item: Record<string, any> | null, // eslint-disable-line @typescript-eslint/no-explicit-any
  ) => {
    try {
      const itemString = item ? JSON.stringify(item) : '';
      return localStorage.setItem(key, itemString);
    } catch (e) {
      console.error(e);
    }
  },
  getJSONItem: <T>(key: string): T | null => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  removeItem: (key: string) => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error(e);
    }
  },
};
